import { Col, Form, Input, Row  } from "antd";
import React, { Fragment } from "react"
import { translate } from "react-i18next";
import { compose } from "redux";
import { formItemLayout } from "../ConnectionControl";
//import FileInput from "../../../../../components/file-input";

// const connectionTypeArray = [
//     {
//         label: "Wallet",
//         value: 1
//     },
//     {
//         label: "Basic",
//         value: 2
//     }
// ]

const FormDbTypeORACLE = ({
    t,
    form,
    creating,
    //connectionDetail
}) => {

    // const [selectedOracleConfigurationFile, setSelectedOracleConfigurationFile] = useState(null);

    // useEffect(() => {
    //     if (!!selectedOracleConfigurationFile) {
    //         form.setFieldsValue({'oracleConfigurationFile': selectedOracleConfigurationFile});
    //     } else {
    //         form.setFieldsValue({'oracleConfigurationFile': null});
    //     }
    // }, [form.getFieldValue("oracleConfigurationFile"),selectedOracleConfigurationFile]);


    return(
        <Fragment>
            {/*<Col>
                <Row>
                    <Form.Item 
                        label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.oracle.connectionType')}
                        className="form-item-required"
                        {...formItemLayout}
                        >
                         {form.getFieldDecorator('connectionType',{})(
                            <Select disabled={!creating} >
                                {
                                    connectionTypeArray.map((connectionType,index) =>
                                    <Select.Option key={index} 
                                        value={connectionType.value} 
                                        title={connectionType.label}>
                                        {connectionType.label}
                                    </Select.Option>
                                    )
                                }
                            </Select>
                        )} 
                    </Form.Item>
                </Row>
            </Col>*/}
            {/* Basic */}
            {/* {form.getFieldValue('connectionType') === 2 && */}
                <Fragment>
                    <Col>
                        <Row>
                            <Form.Item
                                label="Server:"
                                {...formItemLayout}
                                >
                                {form.getFieldDecorator('server')(
                                    <Input 
                                    type="text"
                                    />
                                )}
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Form.Item
                                label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mySql.port')}
                                {...formItemLayout}
                                >
                                {form.getFieldDecorator('port')(
                                    <Input 
                                        type="number"
                                    />
                                )}
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Form.Item
                                label="SID:"
                                className="form-item-required"
                                {...formItemLayout}
                                >
                                {form.getFieldDecorator('sid')(
                                    <Input 
                                    type="text"
                                    />
                                )}
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Form.Item
                                label="User ID:"
                                className="form-item-required"
                                {...formItemLayout}
                                >
                                {form.getFieldDecorator('userId')(
                                    <Input 
                                    type="text"
                                    />
                                )}
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Form.Item
                                label="Password:"
                                className="form-item-required"
                                {...formItemLayout}
                                >
                                {form.getFieldDecorator('password')(
                                    <Input 
                                        type="password"
                                    />
                                )}
                            </Form.Item>
                        </Row>
                    </Col>
                </Fragment>
            {/* }
            {/* Wallet */}
            {/* {form.getFieldValue('connectionType') === 1 && 
                <Fragment>
                    <Col>
                        <Row>
                            <Form.Item
                                label="Data Source:"
                                className="form-item-required"
                                {...formItemLayout}
                                >
                                {form.getFieldDecorator('dataSource')(
                                    <Input 
                                        type="text"
                                        disabled={!creating} 
                                    />
                                )}
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            {form.getFieldDecorator('oracleConfigurationFile')(
                                <Form.Item
                                    label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.oracle.configurationFile')}
                                    className="form-item-required"
                                    {...formItemLayout}
                                    >
                                        <FileInput
                                            value={(!!connectionDetail && !!connectionDetail.oracleConfigurationFile) ? connectionDetail.oracleConfigurationFile : (!!selectedOracleConfigurationFile && !!selectedOracleConfigurationFile.name ? selectedOracleConfigurationFile : null)}
                                            accept={('.zip')}
                                            isZipAllowed
                                            onChange= {(file) => setSelectedOracleConfigurationFile(file)}
                                            onReset={() => setSelectedOracleConfigurationFile(null)}
                                        />
                                </Form.Item>
                            )}
                        </Row>
                    </Col>
                </Fragment>
            }  */}
        </Fragment>
    )
};

export default compose(
    translate()
)(FormDbTypeORACLE)